"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../icon/Icon"));

var _Tag = require("./Tag.style");

var _excluded = ["startIcon", "endIcon", "label"];

var Tag = function Tag(_ref) {
  var startIcon = _ref.startIcon,
      endIcon = _ref.endIcon,
      label = _ref.label,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Tag.StyledTag, props, startIcon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    iconName: startIcon,
    size: 16,
    mr: 2
  }), ' ', label && /*#__PURE__*/_react["default"].createElement("span", {
    className: "eui-tag-label"
  }, label), endIcon && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "eui-tag-divider"
  }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    iconName: endIcon,
    size: 16,
    ml: 2
  })));
};

Tag.defaultProps = {
  color: 'primary',
  variant: 'action'
};
Tag.propTypes = {
  startIcon: _propTypes["default"].string,
  endIcon: _propTypes["default"].string,
  label: _propTypes["default"].string,
  className: _propTypes["default"].string,
  variant: _propTypes["default"].oneOf(['base', 'action', 'status']),
  color: _propTypes["default"].oneOf(['base', 'primary', 'secondary', 'success', 'warning', 'error'])
};
var _default = Tag;
exports["default"] = _default;